import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { BookOpen, ChevronRight } from "lucide-react";
import { readingPreview } from "../../utils/contentForReading";
import { textReaderPath } from "../../utils/textRoutes";
import { useReadingArticles } from "../../hooks/useReadingArticles";
import deskGlass from "../../styles/deskGlass";
import "./reading.css";

const styles = deskGlass;

export default function ReadingQueueBanner() {
  const navigate = useNavigate();
  const { loading, counts, unread, catchUpQueue } = useReadingArticles();

  if (loading || catchUpQueue.length === 0) return null;

  const startCatchUp = () => {
    const first = catchUpQueue[0];
    navigate(textReaderPath(first), {
      state: {
        readingMode: true,
        queue: catchUpQueue.map((a) => a.id),
        queueIndex: 0,
        returnTo: "/",
      },
    });
  };

  return (
    <section style={{ ...styles.glassSection, marginBottom: "12px" }}>
      <div style={styles.glassHeader}>
        <BookOpen size={18} color="#4ade80" />
        <h2 style={styles.glassTitle}>Lecturas pendientes</h2>
        <span style={{ ...styles.subtext, marginLeft: "auto", fontSize: "0.75rem" }}>
          {counts.unread} sin leer
        </span>
      </div>

      <p style={{ ...styles.subtext, margin: "0 0 12px", fontSize: "0.85rem" }}>
        Leé, swipeá → leído / después / repasar. Te vas poniendo al día.
      </p>

      <div className="reading-list" style={{ marginBottom: "12px" }}>
        {unread.slice(0, 3).map((art) => (
          <Link
            key={art.id}
            to={textReaderPath(art)}
            state={{
              readingMode: true,
              queue: catchUpQueue.map((a) => a.id),
              queueIndex: catchUpQueue.findIndex((a) => a.id === art.id),
              returnTo: "/",
            }}
            className="reading-card reading-card--unread"
            style={{ textDecoration: "none", color: "inherit", display: "block" }}
          >
            <div className="reading-card__main" style={{ cursor: "pointer" }}>
              <div className="reading-card__body">
                <h3 className="reading-card__title">{art.title || "Sin título"}</h3>
                <p className="reading-card__preview">{readingPreview(art.content, 100)}</p>
              </div>
            </div>
          </Link>
        ))}
      </div>

      <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
        <button type="button" className="reading-session-btn" style={{ flex: 1, marginBottom: 0 }} onClick={startCatchUp}>
          <BookOpen size={16} />
          Ponerte al día ({catchUpQueue.length})
        </button>
        <Link
          to="/read"
          style={{ ...styles.viewToggle, color: "#D4AF37", textDecoration: "none", display: "flex", alignItems: "center", gap: "4px", padding: "10px 14px" }}
        >
          Ver todo <ChevronRight size={14} />
        </Link>
      </div>
    </section>
  );
}
